export default __webpack_public_path__ + "static/media/redcamera.a4591e35.svg";